import angular from 'angular';
import languageService from './language.service';

class SharedService {
    constructor(languageService, CONFIG) {
        'ngInject';
        this.languageService = languageService;
        this.CONFIG = CONFIG;
    }

    getBaseUrl() {
        if (this.languageService.currentLanguage.key === 'en') {
            return this.CONFIG.website.baseUrl + '/help';
        } else {
            return this.CONFIG.website.baseUrl + '/' + this.languageService.currentLanguage.key + '/help';
        }
    }
}

const sharedServiceModule = angular.module('st.services.helpCentre', [languageService])
    .service('helpCentreService', SharedService)
    .name;

export default sharedServiceModule;


// WEBPACK FOOTER //
// ./client/app/services/helpCentre.service.js